module.exports = __webpack_public_path__ + "media/boost.27fb36a2.webm";